// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1nsDj","filesListContainer":"PosDisputesFiles_filesListContainer__3W8ZX","filesButton":"PosDisputesFiles_filesButton__9osxw"};